import numeral from "numeral";
import { MerkleTree } from 'merkletreejs';
import { utils } from 'ethers';
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import moment from 'moment-timezone';
import _ from 'lodash';
import { isBrowser } from '../hooks/useBrowserDetection';

// import { signOutClearAuthTokens } from '../services/auth';

export const centerShortenLongString = (string, maxLength) => {
	if(typeof string === 'string') {
		if(string.length > maxLength) {
			let charCountForRemoval = string.length - maxLength;
			let stringHalfwayPoint = Math.floor(maxLength/2);
			string = string.slice(0, stringHalfwayPoint) + "..." + string.slice(stringHalfwayPoint + charCountForRemoval, string.length);
			return string;
		}else{
			return string;
		}
	}else{
		return '';
	}
}

export const toChecksumAddress = (string) => {
	let checksumHolderAddress = string;
	try {
		checksumHolderAddress = utils.getAddress(string);
	} catch (error) {
		return string;
	}
	return checksumHolderAddress;
}

export const APP_CONFIG_ALL_ENVS = {
  "localhost": {
		PROJECT_ROOT: "/home",
		API_BASE_URL: "https://dev.api.propy.com/api/",
		API_TP_BASE_URL: "https://dev.tp.propy.com/api/",
		API_IDENTITY_SERVER_URL: "https://dev.is.propy.com",
		API_IDENTITY_SERVICE_CLIENT_ID: "propy-web",
		BASE_URL: "https://dev.propy.com",
    DAPP_BASE_URL: "https://dev.dapp.propy.com",
		DAPP_API_BASE_URL: "https://dev.dappapi.propy.com",
		ONBOARDING_ROOT: "/get-started",
    ONBOARDING_REMOTE_ROOT: "/get-started",
    GOOGLE_ANALYTICS_ID: "G-TPR0EZ4CBK",
    GOOGLE_GTAG_ID: "GTM-NJL65DN",
    CLARITY_ID: "ymt5zifqvx",
    HUBSPOT_ID: "139498176",
    RECAPTCHA_KEY: "6LdHZMYcAAAAAHIRv9v-MF5fca2P0Ju5Hf7t1Sxk",
    ONBOARDING_MEETING_LINK: "https://meetings.hubspot.com/dev123",
 },
 "development": {
		PROJECT_ROOT: "/home",
		API_BASE_URL: "https://dev.api.propy.com/api/",
		API_TP_BASE_URL: "https://dev.tp.propy.com/api/",
		API_IDENTITY_SERVER_URL: "https://dev.is.propy.com",
		API_IDENTITY_SERVICE_CLIENT_ID: "propy-web",
		BASE_URL: "https://dev.propy.com",
    DAPP_BASE_URL: "https://dev.dapp.propy.com",
		DAPP_API_BASE_URL: "https://dev.dappapi.propy.com",
		ONBOARDING_ROOT: "/get-started",
    ONBOARDING_REMOTE_ROOT: "https://dev.propy.com/home/get-started",
    GOOGLE_ANALYTICS_ID: "G-TPR0EZ4CBK",
    GOOGLE_GTAG_ID: "GTM-NJL65DN",
    CLARITY_ID: "ymt5zifqvx",
    HUBSPOT_ID: "139498176",
    RECAPTCHA_KEY: "6LdHZMYcAAAAAHIRv9v-MF5fca2P0Ju5Hf7t1Sxk",
    ONBOARDING_MEETING_LINK: "https://meetings.hubspot.com/dev123",
 },
 "stage": {
		PROJECT_ROOT: "/home",
		API_BASE_URL: "https://stage.api.propy.com/api/",
		API_TP_BASE_URL: "https://stage.tp.propy.com/api/",
		API_IDENTITY_SERVER_URL: "https://stage.is.propy.com",
		API_IDENTITY_SERVICE_CLIENT_ID: "propy-web",
		BASE_URL: "https://stage.propy.com",
    DAPP_BASE_URL: "https://dev.dapp.propy.com",
		DAPP_API_BASE_URL: "https://stage.dappapi.propy.com",
		ONBOARDING_ROOT: "/get-started",
    ONBOARDING_REMOTE_ROOT: "https://stage.propy.com/home/get-started",
    GOOGLE_ANALYTICS_ID: "G-TPR0EZ4CBK",
    GOOGLE_GTAG_ID: "GTM-NJL65DN",
    SMARTLOOK_ID: "6bb5a0bdab863c838a4ecf0000364eec693fa91e",
    CLARITY_ID: "ymt66idrdo",
    HUBSPOT_ID: "4204561",
    RECAPTCHA_KEY: "6LdHZMYcAAAAAHIRv9v-MF5fca2P0Ju5Hf7t1Sxk",
    ONBOARDING_MEETING_LINK: "https://meetings.hubspot.com/dev123",
	},
 "production": {
		PROJECT_ROOT: "/home",
		API_BASE_URL: "https://api.propy.com/api/",
		API_TP_BASE_URL: "https://tp.propy.com/api/",
		API_IDENTITY_SERVER_URL: "https://is.propy.com",
		API_IDENTITY_SERVICE_CLIENT_ID: "propy-web",
		BASE_URL: "https://propy.com",
    DAPP_BASE_URL: "https://dapp.propy.com",
		DAPP_API_BASE_URL: "https://dappapi.propy.com",
		ONBOARDING_ROOT: "/get-started",
    ONBOARDING_REMOTE_ROOT: "https://propy.com/home/get-started",
    GOOGLE_ANALYTICS_ID: "G-TPR0EZ4CBK",
    GOOGLE_GTAG_ID: "GTM-NJL65DN",
    SMARTLOOK_ID: "6bb5a0bdab863c838a4ecf0000364eec693fa91e",
    CLARITY_ID: "yfmddbbwij",
    HUBSPOT_ID: "4204561",
    RECAPTCHA_KEY: "6LdHZMYcAAAAAHIRv9v-MF5fca2P0Ju5Hf7t1Sxk",
    ONBOARDING_MEETING_LINK: "https://meetings.hubspot.com/eric-l-cruz/homepage-workflow",
	}
}

export const GATSBY_ENV = process.env.GATSBY_ENV;
export const IS_LOCALHOST = process.env.GATSBY_IS_LOCAL ? true : false;
export const APP_CONFIG = IS_LOCALHOST ? APP_CONFIG_ALL_ENVS['localhost'] : APP_CONFIG_ALL_ENVS[process.env.GATSBY_ENV ? process.env.GATSBY_ENV : "development"];

export const ONBOARDING_ROOT = APP_CONFIG.ONBOARDING_ROOT;
export const ONBOARDING_REMOTE_ROOT = APP_CONFIG.ONBOARDING_REMOTE_ROOT;
export const PROJECT_ROOT = APP_CONFIG.PROJECT_ROOT; // using "/home" while site is on dev.propy.com/home/
export const API_BASE_URL = APP_CONFIG.API_BASE_URL;
export const API_TP_BASE_URL = APP_CONFIG.API_TP_BASE_URL;
export const API_IDENTITY_SERVER_URL = APP_CONFIG.API_IDENTITY_SERVER_URL;
export const API_IDENTITY_SERVICE_CLIENT_ID = APP_CONFIG.API_IDENTITY_SERVICE_CLIENT_ID;
export const BASE_URL = APP_CONFIG.BASE_URL;
export const DAPP_BASE_URL = APP_CONFIG.DAPP_BASE_URL;
export const DAPP_API_BASE_URL = APP_CONFIG.DAPP_API_BASE_URL;
export const ONBOARDING_MEETING_LINK = APP_CONFIG.ONBOARDING_MEETING_LINK;
export const STAKING_V3_URL = `${DAPP_BASE_URL}/#/earn/v3`;
export const WORDPRESS_URL = "https://propy.com";

export const UNISWAP_PRO_ETH_POOL_URL = "https://app.uniswap.org/explore/pools/base/0xb0e962D88daE312F030771D19868EB4901E0F709";
export const UNISWAP_PRO_ETH_CREATE_POSITION_URL = "https://app.uniswap.org/positions/create/v3?currencyA=0x18dD5B087bCA9920562aFf7A0199b96B9230438b&currencyB=NATIVE&chain=base&feeTier=10000";
export const UNISWAP_PRO_TOKEN_URL = "https://app.uniswap.org/explore/tokens/ethereum/0x226bb599a12c826476e3a771454697ea52e9e220";

export const RECAPTCHA_KEY = APP_CONFIG.RECAPTCHA_KEY;

export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";

export const PROPY_LIGHTER_GREY = "#AAACBA";

export const PROPY_LIGHT_GREY = "#f6f6f6";

export const PROPY_SPACE_GREY_LIGHT = "#696B84";

export const PROPY_SPACE_GREY_SECONDARY = "#394461";

export const PROPY_SPACE_GREY_DARK = "#333333";

export const PROPY_BLACK = "#000000";

export const PROPY_WHITE = "#FFFFFF";

export const PROPY_LIGHT_BLUE = "#38A6FB";

export const PROPY_FADED_GREY = "#E8EAEF";

export const PROPY_BLUE = "#38a6fa";
export const PROPY_BLUE_DARK = "#007BDA";

export const COLORS_PRIMARY_500 = "#7C7F95";
export const COLORS_PRIMARY_800 = "#434552";
export const COLORS_PRIMARY_900 = "#30323C";
export const COLORS_PRIMARY_10 = "#AAACBA1A";

export const IS_GLOBAL_TOP_BANNER_ENABLED = false;
export const GLOBAL_TOP_BANNER_HEIGHT = 28;
export const GLOBAL_PAGE_HEIGHT = IS_GLOBAL_TOP_BANNER_ENABLED ? `calc(100vh - ${64 + GLOBAL_TOP_BANNER_HEIGHT}px)` : 'calc(100vh - 64px)';

export const GOOGLE_MAPS_API_KEY = "AIzaSyDzuZpv8iXJL2lPLqvKU0J4KdFONwSPjGk";
export const HUBSPOT_PORTAL_ID = "4204561";

export const shuffleArray = (array) => {
  const shuffled = [...array];
  
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  
  return shuffled;
}

export function extractPropertyLotSize(data, returnType) {
	let result = {
		value: Math.floor(data?.value),
		label: "",
	}
	if(data?.type === 1) {
		result.label = "ft²"
	}
	if(returnType) {
		return result[returnType]
	}
	return result
}

const getDynamicFormat = (currentFormat = '0,0.00', number) => {
	let requestedDecimals = 0;
	let preDecimalFormat;
	let postDecimalFormat;
	if(currentFormat.split(".").length > 0) {
			requestedDecimals = currentFormat.split(".")[1].length;
			postDecimalFormat = currentFormat.split(".")[1];
			preDecimalFormat = currentFormat.split(".")[0];
	}
	let currentFormattedNumber = numeral(number).format(currentFormat).toString();
	let currentFormattedDecimals = '';
	if(currentFormattedNumber.split('.') && currentFormattedNumber.split('.')[1]) {
			currentFormattedDecimals = currentFormattedNumber.split('.')[1];
	}
	let currentUnformattedDecimals = '';
	if(number.toString().split(".").length > 0 && number.toString().split(".")[1]) {
			currentUnformattedDecimals = number.toString().split(".")[1];
	}
	let dynamicFormat = currentFormat;
	if((currentFormattedDecimals.replace(/[^1-9]/g,"").length < requestedDecimals) && (currentUnformattedDecimals.replace(/[^1-9]/g,"").length >= requestedDecimals)) {
			let indexOfSignificantFigureAchievement = 0;
			let significantFiguresEncountered = 0;
			let numberString = number.toString();
			let numberStringPostDecimal = "";
			if(numberString.split(".").length > 0) {
					numberStringPostDecimal = numberString.split(".")[1]
			}
			for(let i = 0; i < numberStringPostDecimal.length; i++) {
					// @ts-ignore
					if((numberStringPostDecimal[i] * 1) > 0) {
							significantFiguresEncountered++;
							if(significantFiguresEncountered === requestedDecimals) {
									indexOfSignificantFigureAchievement = i + 1;
							}
					}
			}
			if(indexOfSignificantFigureAchievement > requestedDecimals) {
					let requestedDecimalsToSignificantFiguresDelta = indexOfSignificantFigureAchievement - requestedDecimals;
					dynamicFormat = preDecimalFormat + ".";
					if(postDecimalFormat) {
							dynamicFormat = preDecimalFormat + "." + postDecimalFormat;
					}
					for(let i = 0; i < requestedDecimalsToSignificantFiguresDelta; i++) {
							dynamicFormat = dynamicFormat + "0";
					}
			}
	}
	return dynamicFormat;
}

export const priceFormat = (number, decimals = 2, currency = "$", prefix = true) => {
	let decimalString = "";
	for(let i = 0; i < decimals; i++){
			decimalString += "0";
	}
	if (currency.length > 1) {
			prefix = false;
	}
	let format = '0,0.' + decimalString;
	if(Number(number) < 10) {
			format = getDynamicFormat(format, number);
	}
	let result = numeral(number).format(format);
	if(result === 'NaN') {
		result = '0.00';
	}
	if (prefix) {
			return `${currency}${'\u00A0'}`+ result;
	} else {
			return result + `${'\u00A0'}${currency}`
	}
}

export const setCookie = (name, value, days) => {
  const date = new Date();
  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";SameSite=Strict;path=/";
}

export const getCookieValue = (name) => (
  document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
)

export const uuid = () => {
	/*eslint-disable */
  return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
	/*eslint-enable */
}

export const buildQueryStringFromParams = (params) => {
  if (!params || params.length === 0) {
    return '';
  }
  const queryString = params
    .map(param => `${encodeURIComponent(param.key)}=${encodeURIComponent(param.value)}`)
    .join('&');
  return `?${queryString}`;
};

export const trackCustomEvent = ({
  category,
  action,
  label,
  value
}) => {
	try {
		if (typeof window !== 'undefined' && window.gtag) {
			window.gtag('event', action, {
				event_category: category,
				event_label: label,
				value: value
			})
			
			if (process.env.GATSBY_ENV === 'development') {
				console.log('Event tracked:', {
					category,
					action,
					label,
					value
				})
			}
		}
	} catch (e) {
		console.log("Error tracking event");
	}
}

export const getRandomElement = (array) => {
	if (!array || array.length === 0) {
			return null;
	}
	return array[Math.floor(Math.random() * array.length)];
}

export const merkleTreeGenerator = async (whitelist) => {
  const leaves = Object.entries(whitelist).map((x) =>  {
    return utils.solidityKeccak256(["address", "uint256"], [x[0], x[1]]);
  });
  const tree = new MerkleTree(leaves, utils.keccak256, { sortPairs: true });
  const root = tree.getRoot().toString('hex');
  return '0x' + root;
}

export const merkleTreeGenerateProof = async (whitelist, ethAddress, amount) => {
  const leaves = Object.entries(whitelist).map((x) =>  {
    return utils.solidityKeccak256(["address", "uint256"], [x[0], x[1]]);
  });
  const tree = new MerkleTree(leaves, utils.keccak256, { sortPairs: true });
  const leaf = utils.solidityKeccak256(["address", "uint256"], [ethAddress, amount]);
  const proof = tree.getHexProof(leaf);
  return proof;
}

export const NETWORK_ID_TO_NAME = {
	1: 'ethereum',
	42161: 'arbitrum',
  8453: 'base',
  ...(process.env.GATSBY_ENV !== 'production' && {
    84532: 'base-sepolia',
    84531: 'base-goerli',
    5: 'goerli',
    11155111: 'sepolia',
  })
}

export const NETWORK_ID_TO_RPC = {
  1: (process.env.GATSBY_APP_QUICKNODE_RPC_URL_MAINNET) ? process.env.GATSBY_APP_QUICKNODE_RPC_URL_MAINNET : "",
  42161: (process.env.GATSBY_APP_QUICKNODE_RPC_URL_ARBITRUM) ? process.env.GATSBY_APP_QUICKNODE_RPC_URL_ARBITRUM : "",
  8453: (process.env.GATSBY_APP_QUICKNODE_RPC_URL_BASE) ? process.env.GATSBY_APP_QUICKNODE_RPC_URL_BASE : "",
  ...(process.env.GATSBY_ENV !== 'production' && {
    84532: process.env.GATSBY_APP_QUICKNODE_RPC_URL_BASE_SEPOLIA ? process.env.GATSBY_APP_QUICKNODE_RPC_URL_BASE_SEPOLIA : "",
    11155111: process.env.GATSBY_APP_QUICKNODE_RPC_URL_SEPOLIA ? process.env.GATSBY_APP_QUICKNODE_RPC_URL_SEPOLIA : "",
  })
}

export const NETWORK_NAME_TO_DISPLAY_NAME = {
	'ethereum': 'Ethereum',
	'arbitrum': 'Arbitrum',
  'base': 'Base',
  ...(process.env.GATSBY_ENV !== 'production' && {
    'base-sepolia': 'Base Sepolia',
    'base-goerli': 'Base Goerli',
    'goerli': "Goerli",
    'sepolia': 'Sepolia'
  })
}

export const NETWORK_NAME_TO_ID = {
	'ethereum': 1,
	'arbitrum': 42161,
  'base': 8453,
  ...(process.env.GATSBY_ENV !== 'production' && {
    'base-sepolia': 84532,
    'base-goerli': 84531,
    'goerli': 5,
    'sepolia': 11155111,
  })
}

const ETHERSCAN_PREFIXES_CHAIN_ID = {
	1: 'etherscan.io',
	3: 'ropsten.etherscan.io',
	4: 'rinkeby.etherscan.io',
	5: 'goerli.etherscan.io',
	42: 'kovan.etherscan.io',
	100: '',
	1337: '',
	56: '',
	97: '',
	137: '',
	361: '',
	365: '',
	1285: '',
	80001: '',
	1666600000: '',
	11297108109: '',
	31337: '',
	250: '',
	43114: '',
	19: '',
	1287: '',
	25: '',
	338: '',
	1284: '',
	42262: '',
	588: '',
	69: '',
	10: '',
	42161: 'arbiscan.io',
	421611: '',
	11155111: 'sepolia.etherscan.io',
	84532: 'sepolia.basescan.org',
	8453: 'basescan.org',
}

export function getEtherscanLinkByChainId(
	chainId,
	data,
	type, // 'transaction' | 'token' | 'address' | 'block'
) {
	const prefix = `https://${ETHERSCAN_PREFIXES_CHAIN_ID[chainId] || ETHERSCAN_PREFIXES_CHAIN_ID[1]}`

	switch (type) {
		case 'transaction': {
		return `${prefix}/tx/${data}`
		}
		case 'token': {
		return `${prefix}/token/${data}`
		}
		case 'block': {
		return `${prefix}/block/${data}`
		}
		case 'address':
		default: {
		return `${prefix}/address/${data}`
		}
	}
}

export const ETHERSCAN_PREFIXES_NETWORK_NAME = {
	'ethereum': 'etherscan.io',
	'ropsten': 'ropsten.etherscan.io',
	'rinkeby': 'rinkeby.etherscan.io',
	'goerli': 'goerli.etherscan.io',
	'arbitrum': 'arbiscan.io',
	'sepolia': 'sepolia.etherscan.io',
	'base-sepolia': 'sepolia.basescan.org',
	'base': 'basescan.org'
}

export const debounce = (func, wait = 150) => {
  let timeout;
  
  const debouncedFn = function(...args) {
    const context = this;
    
    if (timeout) {
      clearTimeout(timeout);
    }
    
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
  
  debouncedFn.cancel = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  return debouncedFn;
};
  
export function getEtherscanLinkByNetworkName(
	networkName,
	data,
	type // 'transaction' | 'token' | 'address' | 'block'
) {
	const prefix = `https://${ETHERSCAN_PREFIXES_NETWORK_NAME[networkName] || ETHERSCAN_PREFIXES_NETWORK_NAME['ethereum']}`

	switch (type) {
		case 'transaction': {
		return `${prefix}/tx/${data}`
		}
		case 'token': {
		return `${prefix}/token/${data}`
		}
		case 'block': {
		return `${prefix}/block/${data}`
		}
		case 'address':
		default: {
		return `${prefix}/address/${data}`
		}
	}
}

export const MENU_ENTRIES = [
  {
		featuredEntry: true,
    label: "Buyer",
    id: 'buyer',
    desktopFlyoutTitle: "Buy with Propy",
    desktopFlyoutDescription: "Purchase your next home with next-generation tech and agents.",
    desktopFlyoutHeight: 180,
    ctaLink: `${ONBOARDING_ROOT}/?role=buyer`,
    ctaText: "I'm a buyer",
    innerEntries: [
      [
        {
          label: 'Title & Escrow',
          link: `${WORDPRESS_URL}/browse/propytitle/`,
          external: true,
          featuredEntry: true,
        },
        // {
        //   label: "Crypto Escrow with Coinbase",
        //   link: "https://coinbase.propy.com/escrow/?q=homepage_menu",
        //   external: true,
        //   featuredEntry: true,
        // },
        {
          label: 'Browse All Listings',
          link: `${BASE_URL}/map`,
          external: true,
          featuredEntry: true,
        },
        {
          label: 'Featured Listings',
          link: `${BASE_URL}/featured`,
          external: true,
        },
        // {
        //   label: 'Buy as an RWA',
        //   link: `${BASE_URL}/browse/rwa-for-buyers/`,
        //   external: true,
        // },
      ],
      [
				{
          label: 'Find an Agent',
          link: `${BASE_URL}/search`,
          external: true,
        },
        {
          label: 'Pricing',
          link: `${WORDPRESS_URL}/browse/subscriptions/`,
          external: true,
        },
        {
          label: 'Transaction Platform',
          link: `${WORDPRESS_URL}/browse/transaction-platform/`,
          external: true,
        },
        {
          label: 'Offer Management',
          link: `${WORDPRESS_URL}/browse/real-estate-offer-management/`,
          external: true,
        },
      ],
    ]
  },
  {
		featuredEntry: true,
    label: "Seller",
    id: 'seller',
    desktopFlyoutTitle: "Sell with Propy",
    desktopFlyoutDescription: "Promote your listing to the Propy community - close fast & securely.",
    desktopFlyoutHeight: 200,
    ctaLink: `${ONBOARDING_ROOT}/?role=seller`,
    ctaText: "I'm a seller",
    innerEntries: [
      [
        {
          label: 'Title & Escrow',
          link: `${WORDPRESS_URL}/browse/propytitle/`,
          external: true,
          featuredEntry: true,
        },
        {
          label: 'List A Property',
          link: `${BASE_URL}/list-property`,
          external: true,
          featuredEntry: true,
        },
        {
          label: 'View My Listings',
          link: `${BASE_URL}/settings?selectedTab=MY_LISTINGS`,
          external: true,
        },
        // {
        //   label: 'Sell as an RWA',
        //   link: `${WORDPRESS_URL}/browse/rwa-for-sellers/`,
        //   external: true,
        // },
				{
          label: 'Events & Webinars',
          link: `${WORDPRESS_URL}/browse/webinars/`,
          external: true,
        },
      ],
      [
				{
          label: 'Pricing',
          link: `${WORDPRESS_URL}/browse/subscriptions/`,
          external: true,
        },
        {
          label: 'Transaction Platform',
          link: `${WORDPRESS_URL}/browse/transaction-platform/`,
          external: true,
        },
        {
          label: 'Offer Management',
          link: `${WORDPRESS_URL}/browse/real-estate-offer-management/`,
          external: true,
        },
      ],
    ]
  },
  {
		featuredEntry: true,
    label: "Agent",
    id: 'agent',
    desktopFlyoutTitle: "Buy & Sell with Propy",
    desktopFlyoutDescription: "Our products cater to real estate buyers, sellers & agents",
    desktopFlyoutHeight: 324,
    ctaLink: `${ONBOARDING_ROOT}/?role=agent`,
    ctaText: "I'm an agent",
    innerEntries: [
      [
        {
          label: 'List A Property',
          link: `${BASE_URL}/list-property`,
          external: true,
          featuredEntry: true,
        },
        {
          label: 'Buy A Property',
          link: `${BASE_URL}/map`,
          external: true,
          featuredEntry: true,
        },
        {
          label: 'Net Sheet Calculator',
          link: `${BASE_URL}/quote?src=home-netsheet`,
          external: true,
          featuredEntry: true,
        },
        {
          label: 'Browse All Listings',
          link: `${BASE_URL}/map`,
          external: true,
          featuredEntry: true,
        },
        {
          label: 'Title & Escrow',
          link: `${WORDPRESS_URL}/browse/propytitle/`,
          external: true,
          featuredEntry: true,
        },
        // {
        //   label: 'Record Blockchain Deed',
        //   link: `${BASE_URL}/tp/title-deed`,
        //   external: true,
        // },
        {
          label: 'Membership',
          link: `${WORDPRESS_URL}/subscriptions/`,
          external: true,
        },
        // {
        //   label: 'Earn Propy Tokens',
        //   link: `${WORDPRESS_URL}/browse/rewards/`,
        //   external: true,
        // },
				{
          label: 'FAQ',
          link: `${WORDPRESS_URL}/browse/faq/`,
          external: true,
        },
        {
          label: 'Platform features',
          link: `${WORDPRESS_URL}/browse/newfeatures`,
          external: true,
        },
        {
          label: 'Download Propy App',
          link: `https://apps.apple.com/us/app/propy-real-estate-automated/id1017369540`,
          external: true,
        },
      ],
      [
        {
          label: 'Transaction Platform',
          link: `${WORDPRESS_URL}/browse/transaction-platform/`,
          external: true,
        },
        {
          label: 'Offer Management',
          link: `${WORDPRESS_URL}/browse/real-estate-offer-management/`,
          external: true,
        },
        // {
        //   label: 'Get Crypto Certified',
        //   link: `${WORDPRESS_URL}/browse/crypto-for-real-estate/`,
        //   external: true,
        // },
        // {
        //   label: 'Get Meta Certified',
        //   link: `${WORDPRESS_URL}/browse/meta-agent/`,
        //   external: true,
        // },
        {
          label: 'Propy Blog',
          link: `${WORDPRESS_URL}/browse/blog/`,
          external: true,
        },
        {
          label: 'Events & Webinars',
          link: `${WORDPRESS_URL}/browse/webinars/`,
          external: true,
        },
        {
          label: 'Case Studies',
          link: `${WORDPRESS_URL}/browse/case-studies/`,
          external: true,
        },
        {
          label: 'Newsletter',
          link: `${WORDPRESS_URL}/browse/newsletter/`,
          external: true,
        },
      ],
    ]
  },
  {
		featuredEntry: true,
    label: "Title & Escrow",
    id: 'title-and-escrow',
    // img: TitleAndEscrowIcon,
    external: true,
    link: "https://propy.com/browse/propytitle/"
  },
	{
		featuredEntry: false,
    label: "Open Escrow",
    id: 'open-escrow',
    external: true,
    link: `${BASE_URL}/order?isAgent=true`,
    hideHeroInvisibleSignedOut: true,
  },
  {
		featuredEntry: false,
    label: "Sign In",
    id: 'sign-in',
    external: true,
    link: `${BASE_URL}/login`,
    hideSignedIn: true,
    hideHeroInvisibleSignedOut: true,
  },
  {
    featuredEntry: false,
    label: "Go to Platform",
    id: 'go-to-platform',
    external: true,
    link: `${BASE_URL}/dashboard`,
    hideSignedOut: true,
  },
  // {
  //   featuredEntry: false,
  //   label: "Sign Out",
  //   id: 'sign-out',
  //   hideSignedOut: true,
  //   onClick: () => signOutClearAuthTokens(),
  // }
]
 
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const parseJwt = (token) => {
	var base64Url = token.split('.')[1];
	var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
	var jsonPayload = decodeURIComponent(
			window
					.atob(base64)
					.split('')
					.map(function (c) {
							return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
					})
					.join('')
	);

	return JSON.parse(jsonPayload);
}

export const getDurationBetweenDates = (date1, date2, duration) => {
  const startDate = moment(date1 instanceof Date ? date1 : new Date(date1));
  const endDate = moment(date2 instanceof Date ? date2 : new Date(date2));
  const durationString = duration || 'days';
  return moment.duration(endDate.diff(startDate)).as(durationString);
}

export const deepCopy = (obj) => {
  return _.cloneDeep(obj);
}

// CookieService to try and match the ngx-cookie-service so that hopefully we improve maintainability of the new cookie system between the Angular & React apps
export const CookieService = {
  check(name) {
    if(isBrowser()) {
      return document.cookie.split(';').some(c => c.trim().startsWith(name + '='));
    } else {
      return false;
    }
  },

  get(name) {
    if(isBrowser()) {
      const cookies = document.cookie.split(';');
      const cookie = cookies.find(c => c.trim().startsWith(name + '='));
      return cookie ? decodeURIComponent(cookie.split('=')[1]) : '';
    } else {
      return '';
    }
  },

  getAll() {
    if(isBrowser()) {
    return document.cookie.split(';')
      .reduce((cookies, cookie) => {
        const [name, value] = cookie.split('=').map(c => c.trim());
        if (name) cookies[name] = decodeURIComponent(value);
        return cookies;
      }, {});
    } else {
      return {}
    }
  },

  set(
    name,
    value,
    expires = undefined,
    path = '/',
    domain = null,
    secure = false,
    sameSite = 'Lax'
  ) {
    if(isBrowser()) {
      let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
      
      if (expires !== undefined) {
        if (typeof expires === 'number') {
          const dateExpires = new Date(new Date().getTime() + expires * 1000 * 60 * 60 * 24);
          cookie += `; expires=${dateExpires.toUTCString()}`;
        } else {
          cookie += `; expires=${expires.toUTCString()}`;
        }
      }

      if (path) cookie += `; path=${path}`;
      if (domain) cookie += `; domain=${domain}`;
      if (secure) cookie += '; secure';
      cookie += `; samesite=${sameSite}`;
      document.cookie = cookie;
    }
  },

  delete(
    name,
    path = '/',
    domain = null,
    secure = false,
    sameSite = 'Lax'
  ) {
    if(isBrowser()) {
      let cookie = `${encodeURIComponent(name)}=; expires=${new Date(0).toUTCString()}`;
      if (path) cookie += `; path=${path}`;
      if (domain) cookie += `; domain=${domain}`;
      if (secure) cookie += '; secure';
      cookie += `; samesite=${sameSite}`;
      document.cookie = cookie;
    }
  },

  deleteAll(path = '/', domain = null) {
    if(isBrowser()) {
      const cookies = this.getAll();
      Object.keys(cookies).forEach(name => {
        this.delete(name, path, domain);
      });
    }
  }
};

export const handleExternalRedirect = (to, shouldReplace = false) => {
  if(shouldReplace) {
    window.location.replace(to);
  }
  window.location.href = to;
}

export const toName = (firstName, lastName, middleName) => {
    if (firstName && lastName) {
        if (middleName) {
            return `${firstName} ${middleName} ${lastName}`;
        }
        return `${firstName} ${lastName}`;
    }

    if (firstName) return firstName;

    return lastName;
}

export const isIOS = (includeMac = true) => {
  if (typeof window === "undefined") return false;
  
  const platform =
    window.navigator?.userAgentData?.platform || window.navigator.platform;
  const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
  const iosPlatforms = ["iPhone", "iPad", "iPod"];

  if (iosPlatforms.indexOf(platform) !== -1) {
    return true;
  }

  if(includeMac && macosPlatforms.indexOf(platform) !== -1){
    return true;
  }

  return false;
}